var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.522 44.5217H489.739V489.739H44.522V44.5217Z",
    fill: "#F35325"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M534.261 44.5217H979.478V489.739H534.261V44.5217Z",
    fill: "#81BC06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.522 534.261H489.739V979.478H44.522V534.261Z",
    fill: "#05A6F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M534.261 534.261H979.478V979.478H534.261V534.261Z",
    fill: "#FFBA08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon);
export default __webpack_public_path__ + "static/media/Microsoft_icon.5b61a467638e48af47fd0b269bafe75e.svg";
export { ForwardRef as ReactComponent };